define('doubleclick/interstitial',['require','exports','module','jqueryui/ui/dialog','bam.url/url','tracking/omniture','jquery'],function (require, exports, module) {
    "use strict";

    var dialog   = require('jqueryui/ui/dialog');
    var url      = require('bam.url/url');
    var tracking = require('tracking/omniture');
    var $        = require("jquery");

    var _overlayPreviouslyDisplayed = false;
    var _refreshPauseSeconds;
    var _overlayReference;
    var _dialogReference;
    var _pauseSeconds = 7;

    var _doTrack = function( trackingObject ) {
        var om = new tracking.OmnitureAsync( trackingObject );
        om.assign();
        om.fire();
    };

    /**
     * Returns the Interstitial container as a jQuery object
     * @private
     */
    var _create$InterstitialFrame = function(){

        var _interstitialFrame = new Array("<div id='bam_interstitial'>",
            "<a id='istIstClose' class='close'></a>",
            "<div id='ist_container'>",
            "<div id='ist_countdown'>This ad will disappear in <span id='pauseSeconds'>"+_pauseSeconds+" seconds</span>",
            "</div>",
            "<div id='ist_content'></div>",
            "</div>",
            "</div>");

        return $(_interstitialFrame.join(""));
    };

    /**
     * Closes the overlay. Cleans up event handlers and removes DOM elements
     * related to the interstitial overlay. Once cleanup is finished,
     * a tracking call is sent communicating the context of the user's action
     * @private
     */
    var _exit = function(type){
        
        clearInterval(_refreshPauseSeconds);

        $("body").unbind("keydown");
        
        $("#bam_interstitial").remove();

        if (!_overlayPreviouslyDisplayed){
            _dialogReference.dialog("close");
        }

        var compAction = (type === "clickAd") ? "Ad Click" : (type === "escape") ? "Escape Key" : (type==="timeout") ? "Timeout" : (type==="button") ? "Modal Close('X')" : "Clicked Off Modal";
        var secondaryActivity = (type==="clickAd") ? ": " : ": Ad Close: ";
        var trackArea = "Interstitial Homepage Ad";

        _doTrack({
            isDynamic: false,
            dynamic_component: trackArea,
            dynamic_componentAction: trackArea + secondaryActivity + compAction
        });
    };

    /**
     * Initializes interstitial object. Adds event handlers and creates DOM elements
     * related to the interstitial overlay. Overlay uses jQuery UI and loads CSS for the
     * overlay into the head of the document.
     * @private
     */
    var _init = function(customProps) {
        var props = {
            css : "/shared/css/bam/bam.interstitial.css"
        },
        $interstitialFrame = _create$InterstitialFrame();

        $.extend(props, customProps);

         var link = document.createElement("link");
            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = props.css;
         document.getElementsByTagName("head")[0].appendChild(link);

        _dialogReference = $($interstitialFrame).dialog({
            autoOpen: false,
            show: { effect : "fadeIn"},
            width: props.width + 20, //20 is for the overlays padding - this is an issue with ui's dialog
            modal: true,
            dialogClass: "mlb-interstitial",
            resizable : false,
            open: function(event, ui) {

                _doTrack({
                    isDynamic: false,
                    dynamic_component: "Interstitial Homepage Ad",
                    dynamic_componentAction: "Interstitial Homepage Ad: Ad Open"
                });
                $(".ui-dialog").css("position","absolute")
                .css({
                    "position": "fixed",
                    "width": "auto",
                    "height": "auto",
                    "top": "0",
                    "bottom" : "0",
                    "left": "0",
                    "right" : "0",
                    "background": "rgba(0,0,0,.5)",
                    "text-align" : "center",
                    "line-height" : "1em",
                    "padding-top" : "50%",
                    "vertical-align" : "middle",
                    "z-index": "200000"
                });

                $("#bam_interstitial").css({
                    "display" : "inline-block",
                    "top" : "auto",
                    "left" : "auto",
                    "width" : "auto",
                    "margin" : "-25% auto auto auto",
                    "z-index": "200001"
                });

            },
            overlay: {
                backgroundColor: '#000',
                opacity: props.opacity
            } 
        });

        //hides default titlebar in jQuery UI Modal
        $('.ui-dialog-titlebar').remove();

        //save reference to overlay for actions associated with it
        _overlayReference = $interstitialFrame;

        //setup action and tracking
        $("#bam_interstitial").on("click", ".close", function() {
            _exit('button');
            return false;
        });//mlb-interstitial

        $(document).one("click", ".ui-widget-overlay", function() {
            _exit('offmodal');
            return false;
        });


        _init=null;
    };

    /**
     * Closes interstitial after a timeout. This simulates the "Redirect User after X amount of time" 
     * functionality
     * @private
     */
    var _exitAfterTimeout = function(){
        _refreshPauseSeconds = setInterval(function(){ 
            var pauseSecondsContainer = document.getElementById('pauseSeconds');
            if (_pauseSeconds===1){ _exit('timeout'); }
            if (!!pauseSecondsContainer) { 
                pauseSecondsContainer.innerHTML = --_pauseSeconds>1 ? _pauseSeconds + ' seconds' : _pauseSeconds + ' second'; 
            }
        }, 1000);
    };


    /** 
    * Exits the interstitial. This is for triggering tracking events from
    * within the ad's iframe.
    */ 
    exports.exit = function(type) {
        var t = type || 'clickAd';
        _exit(t);
        return true;
    };

    /**
     * Displays interstitial overlay
     * @public
     */
    exports.show = function(customProps){

        var props = {
            campaign       : null,
            width          : null,
            height         : null,
            overlayOpacity : 0.5
        };
        $.extend(props, customProps);

        var frameWidth  = props.width + 20;
        var frameHeight = props.height + 20;
        var $adFrameSrc = $('<iframe src="/components/global/ad_tag_interstitial.jsp?campaign='+props.campaign+'&w='+props.width+'&h='+props.height+'" style="width:'+frameWidth+'px;height:'+frameHeight+'px;" name="ad_interstitial" id="ad_interstitial" frameborder="0" style="" border="0" scrolling="no" />');
        var isFrozen = url.Location(window.location).getParam('istfreeze'); 

        $adFrameSrc.load(function(){ if (!isFrozen){ _exitAfterTimeout(); } });

        if (!!_init) { 
            _init({
                width: props.width,
                height: props.height,
                opacity: props.overlayOpacity
            });
        }

        $(_overlayReference).on( "dialogopen", function( event, ui ) {
            $('#ist_content').append($adFrameSrc);
        });

        _dialogReference.dialog("open");

        if (typeof props.width!=="undefined") {
            $("#ist_container").width(props.width+"px");
        }

        $("#overlay").show().click(function(e){
            e.preventDefault();
            _exit();
        });

        $("body").keydown(function(e){
            if (e.keyCode===27){
                e.preventDefault();
                _exit('escape');
            }
        });

    };
});
